import ChartsOutcomes from "./ChartsOutcomes";

export default ChartsOutcomes;